import './CSS/styles.css';

export default function Login({onSubmit=()=>{} }) {
  
    const handleSubmit = (e) => {
      e.preventDefault();
  
      const values = Object.fromEntries(new FormData(e.target));
  
      onSubmit(values.username);
    };
  
    return (
      <form className="Login" onSubmit={handleSubmit}>
        <h1>
         
          <strong>Welcome to Community</strong>
        </h1>
        <label>username/Email</label>
        <input type="text" name="username" placeholder="Enter your mail" required />
        <label>password</label>
        <input type="password" name="password" placeholder='Enter your password' required />
        <button type="submit">Login</button>
      </form>
    );
  }